// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Mention = function Mention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 3.5c-3.59 0-6.5 2.91-6.5 6.5s2.91 6.5 6.5 6.5c.416 0 .75.334.75.75s-.334.75-.75.75a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8v.875a2.875 2.875 0 0 1-5.228 1.65A3.749 3.749 0 0 1 6.25 10a3.749 3.749 0 0 1 6.119-2.906.752.752 0 0 1 1.381.406v3.375a1.375 1.375 0 1 0 2.75 0V10c0-3.59-2.91-6.5-6.5-6.5m2.25 6.5A2.25 2.25 0 0 0 10 7.75 2.25 2.25 0 0 0 7.75 10 2.25 2.25 0 0 0 10 12.25 2.25 2.25 0 0 0 12.25 10"
  }));
};
